export default function Hero() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/11c911b1083dec36b17648a67a204d4b.jpg"
          alt="씽크짐창의융합놀이센터 배경"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/65 via-black/55 to-black/65"></div>
      </div>

      <div className="relative z-10 text-center px-4 md:px-6 max-w-5xl mx-auto w-full pt-20 md:pt-0">
        <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-4 md:mb-6 leading-tight drop-shadow-[0_2px_8px_rgba(0,0,0,0.8)]">
          "움직임으로 사고를 설계하다, 씽크짐"
        </h1>
        
        <p className="text-base sm:text-lg md:text-xl lg:text-2xl text-white mb-3 md:mb-4 font-semibold drop-shadow-[0_2px_6px_rgba(0,0,0,0.8)] px-2">
          "신체 활동과 사고 훈련을 결합한, 아이 성장 중심의 프리미엄 교육 프로그램"
        </p>
        
        <p className="text-sm sm:text-base md:text-lg text-white/90 mb-8 md:mb-12 max-w-3xl mx-auto leading-relaxed drop-shadow-[0_1px_4px_rgba(0,0,0,0.8)] px-4">
          유아부터 초등생까지, 국내 최초! 창의력 전문가와 함께하는 창의 융합 체육 프로그램으로
          <span className="hidden sm:inline"><br /></span>
          <span className="sm:hidden"> </span>
          아이들의 창의적 잠재력을 최대한 발휘할 수 있도록 교육합니다.
        </p>

        <div className="flex flex-col sm:flex-row gap-3 md:gap-4 justify-center items-center px-4">
          <button
            onClick={() => scrollToSection('programs')}
            className="w-full sm:w-auto bg-orange-500 text-white px-6 md:px-8 py-3 md:py-4 rounded-full text-sm md:text-base font-semibold hover:bg-orange-600 transition-all hover:scale-105 shadow-lg whitespace-nowrap"
          >
            프로그램 둘러보기
          </button>
        </div>

        <div className="mt-12 md:mt-16 grid grid-cols-3 gap-4 md:gap-8 max-w-3xl mx-auto px-4">
          <div className="text-center">
            <div className="text-2xl sm:text-3xl md:text-4xl font-bold text-white mb-1 md:mb-2 drop-shadow-[0_2px_6px_rgba(0,0,0,0.8)]">700+</div>
            <div className="text-xs sm:text-sm text-white/90 drop-shadow-[0_1px_4px_rgba(0,0,0,0.8)]">수강생</div>
          </div>
          <div className="text-center">
            <div className="text-2xl sm:text-3xl md:text-4xl font-bold text-white mb-1 md:mb-2 drop-shadow-[0_2px_6px_rgba(0,0,0,0.8)]">3+</div>
            <div className="text-xs sm:text-sm text-white/90 drop-shadow-[0_1px_4px_rgba(0,0,0,0.8)]">전문 강사진</div>
          </div>
          <div className="text-center">
            <div className="text-2xl sm:text-3xl md:text-4xl font-bold text-white mb-1 md:mb-2 drop-shadow-[0_2px_6px_rgba(0,0,0,0.8)]">800+</div>
            <div className="text-xs sm:text-sm text-white/90 drop-shadow-[0_1px_4px_rgba(0,0,0,0.8)]">창의 교육 프로그램</div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-4 md:bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <button
          onClick={() => scrollToSection('brand')}
          className="text-white hover:text-orange-300 transition-colors cursor-pointer"
        >
          <i className="ri-arrow-down-line text-2xl md:text-3xl"></i>
        </button>
      </div>
    </section>
  );
}
